import { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAxiosAdmin from "../lib/axiosAdmin";
import moment from "moment-jalaali";
import momentTimezone from 'moment-timezone';
import {
  Calendar,
  Users,
  Briefcase,
  CreditCard,
  Eye,
  Edit,
  Trash2,
  Plus,
  RefreshCw,
  Clock,
  ClipboardList,
    Loader2, // 👈 این رو اضافه کن
} from "lucide-react";
import {
  setAllDataOfAdminAppointments,
  setAppointmentsAdminAppointments,
  setFilteredAdminAppointments,
} from "../../../redux/action/admin/appointments/action";
import AppointmentFilters from "./AppointmentFilters";
import AppointmentModal from "./AppointmentModal";
import AppointmentModalEdit from "./ModalEdit";
import EditAppointmentModal from "./ModalEdit";
import DeleteOrCancelModal from "./DeleteOrCancelModal";
import CustomerHistoryModal from "./CustomerHistoryModal";
import { toast } from "react-toastify";

const AdminAppointmentsContent = () => {
  const axiosAdmin = useAxiosAdmin();
  const dispatch = useDispatch();

    const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
const [loadMoreHandler, setLoadMoreHandler] = useState(null);

const [editingAppointment, setEditingAppointment] = useState(null);
const [showEditModal, setShowEditModal] = useState(false);


const [deleteTarget, setDeleteTarget] = useState(null);
const [showDeleteModal, setShowDeleteModal] = useState(false);

const handleTrashClick = (appointment) => {

  setDeleteTarget(appointment);
  setShowDeleteModal(true);
};

const handleCancelAppointment = async () => {
  try {
    const res = await axiosAdmin.delete(`/api/admin/appointment/${deleteTarget._id}`, {
      data: { isDeleted: false },
    });

    let updatedAppointment;
    // اگر backend شیء کامل قرار را برگرداند، از آن استفاده می‌کنیم
    if (res.data && res.data.appointment) {
      updatedAppointment = res.data.appointment;
    } else {
      // در غیر این صورت یک کپی از deleteTarget می‌سازیم و بر اساس وضعیت فعلی تغییر می‌دهیم
      const currentStatus = deleteTarget.status;
      if (currentStatus === "لغو شده") {
        // بازگردانی: وضعیت به "تایید شده" برمی‌گردد و cancelInfo حذف می‌شود
        updatedAppointment = {
          ...deleteTarget,
          status: "تایید شده",
          cancelInfo: undefined,
        };
      } else {
        // لغو قرار: وضعیت به "لغو شده" تغییر می‌کند و cancelInfo تنظیم می‌شود
        updatedAppointment = {
          ...deleteTarget,
          status: "لغو شده",
          cancelInfo: {
            canceledBy: "admin",
            canceledAt: new Date().toISOString(),
          },
        };
      }
    }

    // به‌روزرسانی در Redux (جایگزینی آیتم)
    const newAppointments = appointments.map((a) =>
      a._id === updatedAppointment._id ? updatedAppointment : a
    );
    const newFiltered = filtered.map((a) =>
      a._id === updatedAppointment._id ? updatedAppointment : a
    );
    dispatch(setAppointmentsAdminAppointments(newAppointments));
    dispatch(setFilteredAdminAppointments(newFiltered));

    toast.success(res.data?.message || "عملیات با موفقیت انجام شد");
    setShowDeleteModal(false);
  } catch (error) {
    toast.error(error?.response?.data?.message || "خطا در انجام عملیات");
  }
};


const handleDeleteAppointment = async () => {
  try {
    const res = await axiosAdmin.delete(`/api/admin/appointment/${deleteTarget._id}`, {
      data: { isDeleted: true },
    });
    // حذف از ریداکس
    const newAppointments = appointments.filter(a => a._id !== deleteTarget._id);
    const newFiltered = filtered.filter(a => a._id !== deleteTarget._id);
    dispatch(setAppointmentsAdminAppointments(newAppointments));
    dispatch(setFilteredAdminAppointments(newFiltered));
    toast.success("قرار به طور کامل حذف شد");
    setShowDeleteModal(false);
  } catch (error) {
    toast.error(error?.response?.data?.message || "خطا در حذف قرار");
  }
};

  // Redux state
  const { all, appointments, filtered } = useSelector((state) => state.adminAppointments);
  const appointmentsRef = useRef(appointments);
  const filteredRef = useRef(filtered);
  appointmentsRef.current = appointments;
  filteredRef.current = filtered;

  // Local state
  const [loading, setLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [historyCustomer, setHistoryCustomer] = useState(null);

  const handleCustomerHistoryUpdated = useCallback((userId, phone, hasImportantHistory) => {
    const updateHistoryFlag = (list) => list.map((appointment) =>
      (appointment.user?._id?.toString() === userId ||
        appointment.user?.phone === phone)
        ? { ...appointment, hasImportantCustomerHistory: hasImportantHistory }
        : appointment
    );
    const updatedAppointments = updateHistoryFlag(appointmentsRef.current);
    const updatedFiltered = updateHistoryFlag(filteredRef.current);
    appointmentsRef.current = updatedAppointments;
    filteredRef.current = updatedFiltered;
    dispatch(setAppointmentsAdminAppointments(updatedAppointments));
    dispatch(setFilteredAdminAppointments(updatedFiltered));
  }, [dispatch]);

  // Service type mapping
  const serviceTypeMap = {
    kasht: "کاشت",
    retoosh: "روتوش",
    tarmim: "ترمیم",
    lift: "لیفت",
  };

  // Get payment badge color
  const getPaymentBadgeColor = (type) => {
    switch (type) {
      case "زرین پال":
        return "bg-emerald-50 text-emerald-700 ring-emerald-600/20";
      case "کارت به کارت":
        return "bg-sky-50 text-sky-700 ring-sky-600/20";
      case "نامعلوم":
        return "bg-amber-50 text-amber-700 ring-amber-600/20";
      default:
        return "bg-gray-50 text-gray-700 ring-gray-600/20";
    }
  };

  // Get service type in Persian
  const getServiceType = (type) => {
    return serviceTypeMap[type] || type;
  };

  // Manual refresh handler
  const handleRefresh = () => {
    window.location.reload(); // موقتی - بعداً بهتر می‌کنیم
  };

  const handleCancelAndNew = () => {
    
  }

  console.log(filtered);

  return (
    <div className="" dir="rtl">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
          <h1 className="text-3xl font-bold text-gray-800">مدیریت قرارها</h1>
          <div className="flex items-center gap-3">
            {/* Refresh Button */}
            <button
              onClick={handleRefresh}
              disabled={isRefreshing}
              className="flex items-center gap-2 px-4 py-3 rounded-xl text-sm transition text-gray-700 bg-white border-2 border-gray-200 hover:border-purple-300 hover:bg-purple-50 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm hover:shadow"
            >
              <RefreshCw
                className={`w-5 h-5 ${isRefreshing ? "animate-spin" : ""}`}
              />
              <span>به‌روزرسانی</span>
            </button>

            {/* Add Button */}
            <button  onClick={() => setShowAppointmentModal(true)} className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm transition text-white shadow bg-gradient-to-r from-[#543389] to-[#8b6bd9] hover:shadow-lg hover:-translate-y-0.5">
              <Plus className="w-5 h-5" />
              <span>افزودن قرار جدید</span>
            </button>
          </div>
        </div>

        {/* Filters */}
        <AppointmentFilters 
          onRefresh={handleRefresh} 
          loadingMore={loadingMore}
          setHasMore={setHasMore}
          setLoadingMore={setLoadingMore}
          onLoadMoreReady={(handler) => setLoadMoreHandler(() => handler)} // 👈 این خط جدید
        />

        {/* Refresh indicator */}
        {isRefreshing && (
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2.5 rounded-xl mb-4 flex items-center justify-center gap-2 animate-pulse shadow-md">
            <RefreshCw className="w-4 h-4 animate-spin" />
            <span className="font-medium">در حال به‌روزرسانی...</span>
          </div>
        )}

        {/* Table */}
        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          {/* Desktop Table */}
          <div className="hidden lg:block">
            <div className="relative overflow-visible">
              {/* Gradient Overlay Left */}
              <div className="pointer-events-none absolute left-0 top-0 z-10 hidden h-full w-8 bg-gradient-to-r from-white to-transparent md:block" />

              {/* Gradient Overlay Right */}
              <div className="pointer-events-none absolute right-0 top-0 z-10 hidden h-full w-8 bg-gradient-to-l from-white to-transparent md:block" />

              <table className="w-full min-w-[1200px] border-separate border-spacing-0">
                {/* Head */}
                <thead className="sticky top-0 z-20">
                  <tr className="bg-gradient-to-r from-[#543389] to-[#8b6bd9] text-white">
                    <th className="whitespace-normal border-b border-white/10 px-4 py-3.5 text-right text-xs font-semibold tracking-wide">
                      ردیف
                    </th>

                    <th className="whitespace-normal border-b border-white/10 px-4 py-3.5 text-right text-xs font-semibold tracking-wide">
                      وضعیت
                    </th>

                    <th className="whitespace-normal border-b border-white/10 px-4 py-3.5 text-right text-xs font-semibold tracking-wide">
                      کارکن
                    </th>

                    <th className="whitespace-normal border-b border-white/10 px-4 py-3.5 text-right text-xs font-semibold tracking-wide">
                      مشتری
                    </th>

                    <th className="whitespace-normal border-b border-white/10 px-4 py-3.5 text-right text-xs font-semibold tracking-wide">
                      تاریخ رزرو
                    </th>

                    <th className="whitespace-normal border-b border-white/10 px-4 py-3.5 text-right text-xs font-semibold tracking-wide">
                      خدمت
                    </th>

                    <th className="whitespace-normal border-b border-white/10 px-4 py-3.5 text-right text-xs font-semibold tracking-wide">
                      پرداخت
                    </th>

                    <th className="whitespace-normal border-b border-white/10 px-4 py-3.5 text-right text-xs font-semibold tracking-wide">
                      مبلغ
                    </th>

                    <th className="whitespace-normal border-b border-white/10 px-4 py-3.5 text-right text-xs font-semibold tracking-wide">
                      زمان ثبت
                    </th>

                    <th className="whitespace-normal border-b border-white/10 px-4 py-3.5 text-center text-xs font-semibold tracking-wide">
                      عملیات
                    </th>
                  </tr>
                </thead>

                {/* Body */}
                <tbody className="divide-y divide-gray-100 bg-white">
                  {filtered.length === 0 ? (
                    <tr>
                      <td
                        colSpan="10"
                        className="px-6 py-16 text-center text-sm font-medium text-gray-400"
                      >
                        قراری یافت نشد
                      </td>
                    </tr>
                  ) : (
                    filtered.map((appointment, index) => (
                      <tr
                        key={appointment._id}
                        className="group transition-all duration-75 hover:bg-gray-50"
                      >
                        {/* Row Number */}
                        <td className="whitespace-normal px-4 py-3.5 text-sm font-medium text-gray-500">
                          {index + 1}
                        </td>

                        {/* Status */}
                        <td className="whitespace-normal px-4 py-3.5">
                          <span
                            className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset ${
                              appointment.status === "تایید شده"
                                ? "bg-emerald-50 text-emerald-700 ring-emerald-600/20"
                                : appointment.status === "در انتظار"
                                ? "bg-amber-50 text-amber-700 ring-amber-600/20"
                                : appointment.status === "لغو شده"
                                ? "bg-red-50 text-red-700 ring-red-600/20"
                                : appointment.status === "انجام شده"
                                ? "bg-sky-50 text-sky-700 ring-sky-600/20"
                                : "bg-gray-100 text-gray-700 ring-gray-600/20"
                            }`}
                          >
                            {appointment.status}
                          </span>
                        </td>

                        {/* Staff */}
                        <td className="whitespace-normal px-4 py-3.5">
                          <div className="flex items-center gap-3">
                            <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-purple-100 to-purple-200 text-xs font-bold text-purple-700 shadow-sm">
                              {appointment.staff.displayForAdmin?.charAt(0)}
                            </div>

                            <div className="flex flex-col">
                              <span className="text-sm font-semibold text-gray-900">
                                {appointment.staff.displayForAdmin}
                              </span>
                              <span className="text-xs text-gray-500">
                                کارمند مجموعه
                              </span>
                            </div>
                          </div>
                        </td>

                        {/* Customer */}
                        <td className="whitespace-normal px-4 py-3.5">
                          <div className="flex items-center justify-between gap-2">
                            <div className="flex min-w-0 flex-col">
                              <span className="text-sm font-semibold text-gray-900">
                                {appointment.user.name}
                              </span>
                              <span className="text-xs text-gray-500">
                                {appointment.user.phone}
                              </span>
                            </div>
                            <button
                              type="button"
                              onClick={() => setHistoryCustomer(appointment.user)}
                              title={`مشاهده سابقه ${appointment.user.name}`}
                              className="relative inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-2 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:border-purple-300 hover:text-purple-700"
                            >
                              <ClipboardList className="h-3.5 w-3.5" />
                              سابقه مشتری
                              {appointment.hasImportantCustomerHistory && (
                                <span className="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full bg-red-600 ring-2 ring-white" />
                              )}
                            </button>
                          </div>
                        </td>

                        {/* DateTime */}
                        <td className="whitespace-normal px-4 py-3.5">
                          <div className="flex flex-col">
                            <span className="text-sm font-medium text-gray-900">
                              {moment(
                                appointment.datetime.date,
                                "YYYY-MM-DD"
                              ).format("jYYYY/jMM/jDD")}
                            </span>
                            <span className="text-xs text-gray-500">
                              {appointment.datetime.time}
                            </span>
                          </div>
                        </td>

                        {/* Service */}
                        <td className="px-4 py-3.5">
                          <div className="flex flex-col">
                            <span className="whitespace-normal text-sm font-semibold text-gray-900">
                              {appointment.service.name}
                            </span>
                            <span className="text-xs text-gray-500">
                              {getServiceType(appointment.service.type)} •{" "}
                              {appointment.service.method}
                            </span>
                          </div>
                        </td>

                        {/* Payment Type */}
                        <td className="whitespace-normal px-4 py-3.5">
                          <span
                            className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset ${getPaymentBadgeColor(
                              appointment.paymentType
                            )}`}
                          >
                            {appointment.paymentType}
                          </span>
                        </td>

                        {/* Amount */}
                        <td className="whitespace-normal px-4 py-3.5">
                          <div className="flex items-baseline gap-1">
                            <span className="text-sm font-bold text-gray-900">
                              {appointment.amount.toLocaleString()}
                            </span>
                            <span className="text-xs text-gray-500">ریال</span>
                          </div>
                        </td>

                        {/* Created At */}
                        <td className="whitespace-normal px-4 py-3.5">
                          <div className="flex flex-col">
                            <span className="text-xs font-medium text-gray-700">
                              {moment(appointment.createdAt?.slice(0, 19))
                              .add(3, 'hours')
                              .add(30, 'minutes')
                              .format("jYYYY/jMM/jDD")}

                            </span>
                            <span className="text-xs text-gray-500">
                              {moment(appointment.createdAt?.slice(0, 19)).add(3, 'hours')
                              .add(30, 'minutes').format("HH:mm")}
                            </span>
                          </div>
                        </td>

                        {/* Actions */}
                        <td className="whitespace-normal px-4 py-3.5">
                          <div className="flex items-center justify-center gap-1">
                            

                            <button
                              title="ویرایش"
                              className="rounded-lg p-2 text-emerald-600 transition-all duration-200 hover:bg-emerald-50"
                              onClick={() => {
                                if (appointment.status === "لغو شده") {
                                  handleTrashClick(appointment); // باز کردن مدال بازگردانی/حذف
                                } else {
                                  setEditingAppointment(appointment);
                                  setShowEditModal(true);
                                }
                              }}
                            >
                              <Edit className="h-4 w-4" />
                            </button>

                            <button
                              title="حذف"
                               onClick={() => handleTrashClick(appointment)}
                              className="rounded-lg p-2 text-red-600 transition-all duration-200 hover:bg-red-50"
                            >
                              <Trash2 className="h-4 w-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile Responsive Cards */}
          <div className="block lg:hidden p-4">
            {filtered.length === 0 ? (
              <div className="px-4 py-16 text-center text-sm font-medium text-gray-400">
                قراری یافت نشد
              </div>
            ) : (
              <div className="space-y-4">
                {filtered.map((appointment, index) => (
                  <div
                    key={appointment._id}
                    className="bg-gradient-to-br from-white to-gray-50 rounded-2xl border border-gray-200 shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden"
                  >
                    {/* Card Header */}
                    <div className="bg-gradient-to-r from-[#543389] to-[#8b6bd9] px-4 py-3 flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="text-white/80 text-sm font-medium">
                          #{index + 1}
                        </span>
                        <span
                          className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${
                            appointment.status === "تایید شده"
                              ? "bg-emerald-500 text-white"
                              : appointment.status === "در انتظار"
                              ? "bg-amber-500 text-white"
                              : appointment.status === "لغو شده"
                              ? "bg-red-500 text-white"
                              : appointment.status === "انجام شده"
                              ? "bg-sky-500 text-white"
                              : "bg-gray-500 text-white"
                          }`}
                        >
                          {appointment.status}
                        </span>
                      </div>
                      <div className="flex items-center gap-1">
                        
                        <button
                            className="rounded-lg p-2 text-white hover:bg-white/20 transition-colors"
                            onClick={() => {
                              if (appointment.status === "لغو شده") {
                                handleTrashClick(appointment); // باز کردن مدال بازگردانی/حذف
                              } else {
                                setEditingAppointment(appointment);
                                setShowEditModal(true);
                              }
                            }}
                          >
                            <Edit className="w-4 h-4" />
                          </button>
                        <button  onClick={() => handleTrashClick(appointment)} className="rounded-lg p-2 text-white hover:bg-white/20 transition-colors">
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </div>

                    {/* Card Content */}
                    <div className="p-4 space-y-3">
                      {/* Staff */}
                      <div className="flex items-center gap-3 pb-3 border-b border-gray-200">
                        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-purple-100 to-purple-200 text-sm font-bold text-purple-700 shadow-sm">
                          {appointment.staff.displayForAdmin?.charAt(0)}
                        </div>
                        <div className="flex flex-col">
                          <span className="text-xs text-gray-500">کارکن</span>
                          <span className="text-sm font-semibold text-gray-900">
                            {appointment.staff.displayForAdmin}
                          </span>
                        </div>
                      </div>

                      {/* Customer */}
                      <div className="flex items-start gap-2">
                        <Users className="w-4 h-4 text-purple-500 flex-shrink-0 mt-0.5" />
                        <div className="flex flex-col flex-1">
                          <div className="flex items-start justify-between gap-2">
                            <div className="flex min-w-0 flex-col">
                              <span className="text-xs text-gray-500 mb-0.5">مشتری</span>
                              <span className="text-sm font-semibold text-gray-900">
                                {appointment.user.name}
                              </span>
                              <span className="text-xs text-gray-500 mt-0.5">
                                {appointment.user.phone}
                              </span>
                            </div>
                            <button
                              type="button"
                              onClick={() => setHistoryCustomer(appointment.user)}
                              title={`مشاهده سابقه ${appointment.user.name}`}
                              className="relative inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-2 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:border-purple-300 hover:text-purple-700"
                            >
                              <ClipboardList className="h-3.5 w-3.5" />
                              سابقه مشتری
                              {appointment.hasImportantCustomerHistory && (
                                <span className="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full bg-red-600 ring-2 ring-white" />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Date & Time */}
                      <div className="grid grid-cols-2 gap-3">
                        <div className="flex items-start gap-2 bg-purple-50 rounded-xl p-3">
                          <Calendar className="w-4 h-4 text-purple-600 flex-shrink-0 mt-0.5" />
                          <div className="flex flex-col">
                            <span className="text-xs text-purple-600 mb-0.5">
                              تاریخ
                            </span>
                            <span className="text-sm font-medium text-gray-900">
                              {moment(
                                appointment.datetime.date,
                                "YYYY-MM-DD"
                              ).format("jYYYY/jMM/jDD")}
                            </span>
                          </div>
                        </div>

                        <div className="flex items-start gap-2 bg-blue-50 rounded-xl p-3">
                          <Clock className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                          <div className="flex flex-col">
                            <span className="text-xs text-blue-600 mb-0.5">
                              ساعت
                            </span>
                            <span className="text-sm font-medium text-gray-900">
                              {appointment.datetime.time}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Service */}
                      <div className="flex items-start gap-2 bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl p-3">
                        <Briefcase className="w-4 h-4 text-emerald-600 flex-shrink-0 mt-0.5" />
                        <div className="flex flex-col flex-1">
                          <span className="text-xs text-emerald-600 mb-0.5">
                            خدمت
                          </span>
                          <span className="text-sm font-semibold text-gray-900">
                            {appointment.service.name}
                          </span>
                          <span className="text-xs text-gray-600 mt-0.5">
                            {getServiceType(appointment.service.type)} •{" "}
                            {appointment.service.method}
                          </span>
                        </div>
                      </div>

                      {/* Payment & Amount */}
                      <div className="flex items-center justify-between bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-3">
                        <div className="flex items-center gap-2">
                          <CreditCard className="w-4 h-4 text-amber-600" />
                          <span
                            className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset ${getPaymentBadgeColor(
                              appointment.paymentType
                            )}`}
                          >
                            {appointment.paymentType}
                          </span>
                        </div>
                        <div className="flex items-baseline gap-1">
                          <span className="text-base font-bold text-gray-900">
                            {appointment.amount.toLocaleString()}
                          </span>
                          <span className="text-xs text-gray-600">ریال</span>
                        </div>
                      </div>

                      {/* Created At */}
                      <div className="flex items-center justify-center gap-2 text-xs text-gray-500 pt-2 border-t border-gray-200">
                        <Clock className="w-3.5 h-3.5" />
                        <span>
                          ثبت شده:{" "}
                          {moment(appointment.createdAt?.slice(0, 19))
                              .add(3, 'hours')
                              .add(30, 'minutes').format(
                            "jYYYY/jMM/jDD"
                          )}{" "}
                          • {moment(appointment.createdAt?.slice(0, 19))
                              .add(3, 'hours')
                              .add(30, 'minutes').format("HH:mm")}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>



        </div>
            
             {/* 👇 اینجا دکمه "مشاهده بیشتر" رو اضافه کن */}
        {hasMore && (
  <div className="px-4 md:px-6 pb-6 mt-6">
    <button
      onClick={() => loadMoreHandler && loadMoreHandler()} // 👈 تغییر
      disabled={loadingMore}
      className="w-full px-4 py-3 bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white text-sm font-medium rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
    >
      {loadingMore ? (
        <>
          <Loader2 className="w-5 h-5 animate-spin" />
          <span>در حال بارگذاری...</span>
        </>
      ) : (
        <span>بارگذاری قرارهای بیشتر</span>
      )}
    </button>
  </div>
)}

         {showAppointmentModal && (
            <AppointmentModal
              onClose={() => setShowAppointmentModal(false)}
              onSuccess={() => {
                setShowAppointmentModal(false);
                // no need to reload, Redux already updated via dispatch
              }}
            />
          )}

          {showEditModal && (

            <EditAppointmentModal

              show={showEditModal}
              appointment={editingAppointment}
              
              onClose={() => {
                setShowEditModal(false);
                setEditingAppointment(null);
              }}
              
              onSuccess={() => {
                setShowEditModal(false);
              }}

            />

          )}

          <DeleteOrCancelModal
            show={showDeleteModal}
            onClose={() => setShowDeleteModal(false)}
            onCancel={handleCancelAppointment}
            onDelete={handleDeleteAppointment}
            appointment={deleteTarget}
          />

          {historyCustomer && (
            <CustomerHistoryModal
              axiosAdmin={axiosAdmin}
              customer={historyCustomer}
              onClose={() => setHistoryCustomer(null)}
              onUpdated={handleCustomerHistoryUpdated}
            />
          )}

      </div>
    </div>
  );
};

export default AdminAppointmentsContent;